import { isEmpty, is, prop, map, forEach, isNil } from 'ramda';
import { upload } from './request';
import { compressImage, isCompressedImage } from './compressImage';
const FormData = require('form-data');

// A file that already went through `compressImage` (e.g. background images compressed
// once for their preview) is not re-encoded a second time.
export const uploadFiles = async (files, { token } = {}) => {
  if (isNil(files) || (is(Array, files) && isEmpty(files))) return;
  const prepareFile = (file) => (isCompressedImage(file) ? file : compressImage(file));
  const formData = new FormData();
  if (is(Array, files)) {
    const preparedFiles = await Promise.all(map(file => prepareFile(prop('originFileObj', file)), files));
    forEach(preparedFile => formData.append('file', preparedFile), preparedFiles);
  } else {
    formData.append('file', await prepareFile(files));
  }
  return await upload(formData, token);
};
